import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const MessageLeftWrapper = styled.div`
  display: flex;
  margin: 10px 0 45px 0;
  padding-right: 15%;

  ${mediaMaxWidth.phone`
    margin: 10px 0 25px 0;
    padding-right: 5%;
  `}

  ${mediaMaxWidth.smallPhone`
    margin: 10px 0 15px 0;
    padding-right: 10px;
  `}
`;

export const Avatar = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 50%;

  ${mediaMaxWidth.smallPhone`
    height: 30px;
    width: 30px;
  `}
`;

export const Message = styled.div`
  border: 1px solid #c6c6c6;
  border-radius: 8px;
  word-break: break-word;
  margin-left: 20px;
  padding: 12px 15px;
  height: fit-content;
  width: fit-content;
  text-align: left;
  line-height: 1.7em;
  font-weight: 500;
  color: #1d1d1e;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  white-space: pre-wrap;

  ${mediaMaxWidth.phone`
    padding: 5px 10px;
    font-size: 0.8em;
    margin-left: 10px;
  `}

  ${mediaMaxWidth.smallPhone`
    padding: 3px 7px;
    font-size: 0.75em;
    margin-left: 5px;
  `}
`;

export const Label = styled.div`
  text-transform: capitalize;
  font-size: 0.85em;
  font-weight: 700;
  background-color: ${(props) =>
    props.action === "pending" ? "#337ab7" : null};
  background-color: ${(props) =>
    props.action === "added_to_favourites" ? "#337ab7" : null};
  background-color: ${(props) =>
    props.action === "telephone_interview_requested" ? "#673490" : null};
  background-color: ${(props) =>
    props.action === "first_interview_requested" ? "#673490" : null};
  background-color: ${(props) =>
    props.action === "second_interview_requested" ? "#673490" : null};
  background-color: ${(props) =>
    props.action === "competencies_required" ? "#673490" : null};
  background-color: ${(props) =>
    props.action === "offered_job" ? "#f2994a" : null};
  background-color: ${(props) =>
    props.action === "offer_cancelled" ? "#EB5757" : null};
  background-color: ${(props) =>
    props.action === "interview_declined" ? "#EB5757" : null};
  background-color: ${(props) =>
    props.action === "telephone_interview_confirmed" ? "#27AE60" : null};
  background-color: ${(props) =>
    props.action === "first_interview_confirmed" ? "#27AE60" : null};
  background-color: ${(props) =>
    props.action === "second_interview_confirmed" ? "#27AE60" : null};
  background-color: ${(props) =>
    props.action === "competency_test_completed" ? "#27AE60" : null};
  background-color: ${(props) =>
    props.action === "accepted_job" ? "#27AE60" : null};
  background-color: ${(props) =>
    props.action === "declined_interview" ? "#EB5757" : null};
  background-color: ${(props) =>
    props.action === "rejected_job" ? "#EB5757" : null};
  background-color: ${(props) =>
    props.action === "rejected_candidate" ? "#EB5757" : null};
  color: #fff;
  width: fit-content;
  display: table;
  display: ${(props) => (props.action === "send_message" ? "none" : null)};
  border-radius: 4px;
  padding: 2px 8px 1px 25px;
  margin: ${(props) =>
    props.type === "containsText" ? "5px 0 15px 0" : "5px 0"};
  position: relative;

  &::before {
    content: "•";
    color: #fff;
    font-size: 3.1em;
    position: absolute;
    top: 2px;
    left: 5px;
  }

  ${mediaMaxWidth.phone`
    padding: 2px 8px 1px 20px;
  `}
`;

export const AttachmentWrapper = styled.a`
  display: flex;
  transition: 0.15s ease-in-out;
  margin-top: ${(props) => (props.type === "containsText" ? "20px" : "0")};

  &:hover {
    color: #673490;
  }
`;

export const AttachmentIcon = styled.div`
  padding-right: 7px;

  svg {
    font-size: 1.2em;
  }
`;

export const AttachmentName = styled.div`
  width: 370px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline;

  ${mediaMaxWidth.tablet`
    width: 300px;
  `}

  ${mediaMaxWidth.phone`
    width: 210px;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 200px;
  `}
`;
